// extracted by mini-css-extract-plugin
export var benefits = "roiCalculator-module--benefits--a1eb4";
export var benefitsContainer = "roiCalculator-module--benefitsContainer--c87d6";
export var benefitsTextContainer = "roiCalculator-module--benefitsTextContainer--eec43";
export var calculatorContainer = "roiCalculator-module--calculatorContainer--4dee9";
export var calculatorGroupsContainer = "roiCalculator-module--calculatorGroupsContainer--7dde3";
export var calculatorInput = "roiCalculator-module--calculatorInput--17de8";
export var calculatorInputGroup = "roiCalculator-module--calculatorInputGroup--f7953";
export var calculatorInputsGroup = "roiCalculator-module--calculatorInputsGroup--084dd";
export var container = "roiCalculator-module--container--a57c1";
export var ctaContainer = "roiCalculator-module--ctaContainer--bd01f";
export var divider = "roiCalculator-module--divider--b5f4c";
export var footnoteText = "roiCalculator-module--footnoteText--604e0";
export var groupHeading = "roiCalculator-module--groupHeading--f95b8";
export var headerContainer = "roiCalculator-module--headerContainer--4e288";
export var inputCalculationContainer = "roiCalculator-module--inputCalculationContainer--06d22";
export var inputCopyGroup = "roiCalculator-module--inputCopyGroup--10ab7";
export var inputCurrency = "roiCalculator-module--inputCurrency--61aed";
export var inputLabelContainer = "roiCalculator-module--inputLabelContainer--30cb0";
export var inputSubtitle = "roiCalculator-module--inputSubtitle--3d524";
export var inputToolInput = "roiCalculator-module--inputToolInput--21815";
export var inputToolInputContainer = "roiCalculator-module--inputToolInputContainer--18aff";
export var inputToolInputCost = "roiCalculator-module--inputToolInputCost--c40ca";
export var inputToolInputDisabled = "roiCalculator-module--inputToolInputDisabled--0cffa";
export var inputToolInputLabel = "roiCalculator-module--inputToolInputLabel--79ca8";
export var inputToolInputRadioLabel = "roiCalculator-module--inputToolInputRadioLabel--36f88";
export var inputToolOptions = "roiCalculator-module--inputToolOptions--22822";
export var moduleContainer = "roiCalculator-module--moduleContainer--0a9db";
export var recalculateButton = "roiCalculator-module--recalculateButton--2f6fe";
export var results = "roiCalculator-module--results--b2635";
export var resultsContainer = "roiCalculator-module--resultsContainer--b753e";
export var resultsHeader = "roiCalculator-module--resultsHeader--e3aad";
export var resultsNoSavingsHeader = "roiCalculator-module--resultsNoSavingsHeader--6e1cb";
export var resultsOverlay = "roiCalculator-module--resultsOverlay--a3325";
export var resultsOverlayVisible = "roiCalculator-module--resultsOverlayVisible--96564";
export var resultsTimeContainer = "roiCalculator-module--resultsTimeContainer--441c1";
export var resultsToggle = "roiCalculator-module--resultsToggle--66db5";
export var resultsToggleLabel = "roiCalculator-module--resultsToggleLabel--b4ad7";
export var resultsToggleLabelActive = "roiCalculator-module--resultsToggleLabelActive--577e0";
export var slider = "roiCalculator-module--slider--31e34";